module.exports = __webpack_public_path__ + "img/learning-student.a98e809b.svg";